var map = {
	"./config": 420,
	"./config.js": 420,
	"./index": 408,
	"./index.js": 408,
	"./option-manager": 405,
	"./option-manager.js": 405,
	"./parsers": 409,
	"./parsers.js": 409,
	"./removed": 432,
	"./removed.js": 432
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 433;



/*****************
 ** WEBPACK FOOTER
 ** ./~/babel-core/lib/transformation/file/options ^\.\/.*$
 ** module id = 433
 ** module chunks = 0
 **/